"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionPromise = void 0;
/**
 * Promise representing the response to subscription, and offering an additional
 * cancel() method to stop listening for updates.
 *
 * This is returned from DCRFClient.subscribe.
 */
class SubscriptionPromise extends Promise {
    constructor(executor, unsubscribe) {
        super(executor);
        this.unsubscribe = unsubscribe;
    }
    /**
     * Stop listening for new events on this subscription
     * @return true if the subscription was active, false if it was already unsubscribed
     */
    cancel() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.unsubscribe();
        });
    }
}
exports.SubscriptionPromise = SubscriptionPromise;
